import 'babel-polyfill';
import './rollbar.js';
import React from 'react';
import ReactDOM from 'react-dom';

import store from './store.js';
import App from './app.js';

ReactDOM.render(<App store={store} />, document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js